import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
// import {Link} from "react-router-dom";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Language>{t("Contato")}</Language>
              <Large to="/">{t("Conte-nos tudo")}</Large>
              <Para>
                {t(`Tem alguma dúvida? Fique à vontade para entrar em contato.`)}
              </Para>
              <a href="belomind@gmail.com">
                <Chat>{t(`Vamos conversar`)}</Chat>
                <Para>{t("support@belomind.com")}</Para>
              </a>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Política")}</Title>
              <Large to="/terms-conditions">{t("Our Terms & Conditions")}</Large>
              <Large to="/privacy-policy">{t("Privacy Policy")}</Large>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Empty />
              <Large to="/">{t("Centro de Suporte")}</Large>
              <Large to="/">{t("Suporte ao cliente")}</Large>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Empty />
              <Language>{t("Endereço")}</Language>
              <Para>626 Pleasant St</Para>
              <Para>Boston,Worcester</Para>
              <Para>Massachusetts, USA</Para>
              <br/>
              <Para>+1 (774) 498-9681</Para>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Company")}</Title>
              <Large to="/">{t("Sobre")}</Large>
              <Large to="/">{t("Blog")}</Large>
              <Large to="/">{t("Imprensa")}</Large>
              <Large to="/">{t("Carreiras & Cultura")}</Large>
              <Large to="/privacy-policy">{t("política de Privacidade")}</Large>
              <Large to="/terms-conditions">{t("Termos e Condições")}</Large>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Label htmlFor="select-lang">{t("Idioma")}</Label>
              <LanguageSwitchContainer>
                {/* <LanguageSwitch onClick={() => handleChange("en")}>
                  <SvgIcon
                    src="united-states.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch> */}
                <LanguageSwitch onClick={() => handleChange("es")}>
                  <SvgIcon
                    src="brazil.png"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  src="BeloMind.svg"
                  aria-label="homepage"
                  width="200px"
                  height="64px"
                />
              </LogoContainer>
            </NavLink>
            <FooterContainer>
              <SocialLink
                href="https://www.linkedin.com/company/belomind/about/"
                src="linkedin.svg"
              />
              <SocialLink
                href="https://www.linkedin.com/company/belomind/about/"
                src="facebook.svg"
              />
              <SocialLink
                href="https://www.linkedin.com/company/belomind/about/"
                src="instagram.svg"
              />
              {/* <SocialLink
                href="/"
                src="github.svg"
              /> */}
              {/* <SocialLink
                href="/"
                src="twitter.svg"
              /> */}
              {/* <SocialLink
                href="/"
                src="medium.svg"
              /> */}
              {/* <a
                href="/"
                // target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  height="36"
                  style={{ border: 0, height: 36 }}
                  src="https://storage.ko-fi.com/cdn/kofi3.png?v=3"
                  alt="Buy Me a Coffee at ko-fi.com"
                />
              </a> */}
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
